import React from 'react';

import './styles.scss';
import FindLub from '../FindLub';
import KnowOilPrice from '../KnowOilPrice';

const OilFAQs = () => {


    return (
        <div className="container" id="faq">
            <h2 className="gray-text text-center landing-section-title">Preguntas frecuentes sobre el cambio de aceite</h2>
            <FindLub />
            <KnowOilPrice />
        </div>

    );
};

export default OilFAQs;
